import { Badge, CardContent, Divider, Tab, Tabs } from "@mui/material";
import { ChatMessage, ChatPanel } from "./ChatPanel";

interface OrderMessagesCardProps {
  label: string;
  badgeCount: number;
  messages: ChatMessage[];
  emptyText: string;
  inputValue: string;
  onInputChange: (_value: string) => void;
  onSend: () => void;
  sendDisabled?: boolean;
  placeholder?: string;
  onDelete?: (_id: string | number) => void;
}

export const OrderMessagesCard = ({
  label,
  badgeCount,
  messages,
  emptyText,
  inputValue,
  onInputChange,
  onSend,
  sendDisabled,
  placeholder,
  onDelete,
}: OrderMessagesCardProps) => {
  return (
    <CardContent
      sx={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      <Tabs value={0} variant="fullWidth">
        <Tab
          label={
            <Badge color="primary" badgeContent={badgeCount}>
              {label}
            </Badge>
          }
        />
      </Tabs>

      <Divider sx={{ mb: 2 }} />

      <ChatPanel
        messages={messages}
        emptyText={emptyText}
        inputValue={inputValue}
        onInputChange={onInputChange}
        onSend={onSend}
        sendDisabled={sendDisabled}
        placeholder={placeholder}
        onDelete={onDelete}
      />
    </CardContent>
  );
};
